import React from 'react';
import coinIcon from '../../../../../../assets/svg/coins.svg';

const NoTransactions = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: 100 }}>
      <img src={coinIcon} alt="تراکنشی یافت نشد." height={60} width={60} />
      <div>تراکنشی برای این کاربر یافت نشد. از منوی سمت چپ استفاده کنید.</div>
    </div>
  );
};

export default React.memo(NoTransactions);
